import React, { useState, useEffect } from 'react'
import { getEveBreDecision, getEveBreScore, getBreDecisionAdmin,checkValidationIncomeForLoanById, getRiskcategorizationAdmin, getLoanCalculation, SaveUpdateBreDecision, getEveBreScoreUpdated, getEveBreScoreBorrowercoborrower, updateEligibleLoanAmountByUserId, getcrifStatusByUserID,SaveAdmincrifDecisonbbyData } from '../../../AdminActionCreator.component'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import ViewSection from './ViewSection'
import CrifSection from './CrifSection'
import { APIS } from '../../../../../../utils/api-factory'
import Popup from '../../../../../presentationals/Popup/Popup.component'
import { ROLE } from '../../../../../../utils/Constant'
import html2pdf from "html2pdf.js"

const regenerateParam = 0;

export default function Main({ type, closePopupbtn, LeadData, admin }) {
    { console.log("LeadData", LeadData) }
    const [loader, setloader] = useState(false)
    const [TableData, setTableData] = useState("")
    const [scoreDetail, setscoreDetail] = useState([])
    const [viewType, setViewType] = useState("view")
    const [PopupViewTab, setPopupViewTab] = useState("crif")
    const [crifData, setcrifData] = useState('')
    const [crifDecisionData, setcrifDecisionData] = useState({})
    const [loanCalculationData, setLoanCalculationData] = useState({})
    const [BreUpdate, setBReUpdate] = useState({ show: false, value: {}, type: '', eligibleAmount: '' })
    const [PopupValue, setPopupValue] = useState({ show: false, popupStatus: "" })
    const [showBre, setShowBre] = useState(true)
    const [crifTable, setCrifTable] = useState({})
    const [handlecrif, sethandlecrif] = useState({ show: false, val: "", remarks: "" })

    useEffect(() => {
        if (LeadData?.userFlow == "L5" && LeadData?.userType !== "BORROWER") {
            setShowBre(false)
            setPopupViewTab("crif")
        }

        getEveBreScoreFunction()
        getCrifData(0)
        getBreDecisionAdminFn(0)
        getRiskcategorizationAdminFn()
        getLoanCalculationAPI()
        getcrifStatusByUserIDFn()
    }, [])

    // const getEveBreDecisionFunction = () => {
    //     setloader(true)
    //     getEveBreDecision(LeadData?.userId, (callback) => {
    //         setTableData(callback)
    //         setloader(false)
    //     })
    // }

    const getcrifStatusByUserIDFn = () => {
        getcrifStatusByUserID(LeadData?.userId, callback => {
            if (Object.keys(callback?.data)?.length > 0) {
                setCrifTable(callback?.data || {})
            } else {
                setCrifTable({})
            }
        })
    }

    const getEveBreScoreFunction = () => {
        if (type === "coborrower") {
            setloader(true)
            getEveBreScoreBorrowercoborrower(LeadData?.userId, callback => {
                setscoreDetail(callback)
                setloader(false)
            })
        } else if (type === "borrower") {
            setloader(true)
            getEveBreScoreUpdated(LeadData?.userId, regenerateParam, (callback) => {
                setscoreDetail(callback)
                setloader(false)
                // getEveBreDecisionFunction()
            })
        }


    }

    const getRiskcategorizationAdminFn = () => {
        setloader(true)
        getRiskcategorizationAdmin(LeadData?.userId, "1", (callback) => {
            if (callback && callback?.status == 200 && callback?.message == "success") {
                setTableData(callback?.data)
                setloader(true)
            } else {
                setTableData([])
                setloader(true)
            }

        })
    }
    const handleView = (type) => {
        setViewType(type)
    }

    const PopupbuttonHandle = (type) => {
        setPopupViewTab(type)
    }

    const getCrifData = (param) => {
        setloader(true)
        fetch(
            APIS.GET_CRIF_DATA +
            LeadData.userId +
            '&loanId=' + null +
            '&regenerate=' +
            param
        )
            .then(res => res.text())
            .then(res => {
                if (res && res?.responseCode == 0) {
                    setloader(false)
                } else if (res) {
                    setcrifData(res)

                }
                setloader(false)
            })
    }

    const getBreDecisionAdminFn = (param) => {
        getBreDecisionAdmin(LeadData?.userId, param, admin?.emailId, callback => {
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                setcrifDecisionData(callback?.data)
            } else {
                setcrifDecisionData({})
            }
        })
    }

    const getLoanCalculationAPI = () => {
        setloader(true)
        getLoanCalculation(LeadData?.userId, "0", callback => {
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                setLoanCalculationData(callback?.data)
            } else {
                setLoanCalculationData({})
            }
            setloader(false)
        })
    }

    const handleEditBreDecision = (type, data) => {
        if (type == "breDecision") {
            setBReUpdate({ show: true, value: data?.breDecision, type: type, eligibleAmount: '' })
        } else if (type == "eligibleAmount") {
            setBReUpdate({ show: true, value: '', type: type, eligibleAmount: data?.eligibleAmount })
        }
    }

    const handleUpdateBreDecision = () => {
        if (BreUpdate?.type == "breDecision") {
            const data = {
                userId: LeadData?.userId,
                breDecision: BreUpdate?.value,
            };
            setloader(true)
            SaveUpdateBreDecision(data, (callback) => {
                setloader(false)
                console.log(callback)
                if (callback && callback == "success") {
                    setPopupValue({ show: true, popupStatus: "Urja Decision Updated Successfully" })
                    if(BreUpdate?.value == "Approved"){
                        checkValidationIncomeForLoanById(LeadData?.userId,callback=>{
                            if(callback?.data == true){
                                alert("Please Check, Income does not meet the minimum eligibility criteria for this loan")
                            }
                        })
                    }
                } else {
                    setPopupValue({ show: true, popupStatus: "Error Updating Decision" })
                }
                removePopup()
            })
        } else if (BreUpdate?.type == "eligibleAmount") {
            setloader(true)
            updateEligibleLoanAmountByUserId(LeadData?.userId, BreUpdate?.eligibleAmount, admin?.emailId, (callback) => {
                setloader(false)
                console.log(callback)
                if (callback && callback == "success") {
                    setPopupValue({ show: true, popupStatus: "Eligible Amount Updated Successfully" })
                } else {
                    setPopupValue({ show: true, popupStatus: "Error Updating Eligible Amount" })
                }
                removePopup()
            })

        }
    }

    const closePopup = () => {
        setPopupValue({ show: false, popupStatus: "" })
    }
    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleDownload = () => {
        const element = document.getElementById('crifReportcontent');

        const opt = {

            margin: 3,
            filename: 'crifReport.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a3', orientation: 'portrait' }
        };

        html2pdf().set(opt).from(element).save();
    }

    const handleRegenerate = () => {
        getCrifData(1)
    }

    const handleEditCRifDecision = (type, val) => {
        sethandlecrif({ show: type, val: val?.crifDecision, remarks: "" })
    }

    const savecrifDecision = () => {
        const data = {
            "userId": LeadData?.userId,
            "newDecision": handlecrif?.val,
            "adminId": admin?.emailId,
            "remarks": handlecrif?.remarks
        }
        SaveAdmincrifDecisonbbyData(data,callback=>{
             sethandlecrif({ show: false, val: "", remarks: "" })
              getcrifStatusByUserIDFn()
        })
        
    }

    return (
        <>
            <div className="background-blur">
                {
                    PopupValue?.show ?
                        <Popup closePopup={closePopup} popupStatus={PopupValue.popupStatus} />
                        : ''}

                <div className="popup-main  container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '80%', height: '600px' }}>
                    <i onClick={() => closePopupbtn(false, "")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                    {
                        loader ? <Loader /> : ''
                    }
                    <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-sm-12 btn-group btn-grp-own-logs">
                            <button className="btn btn-outline-primary" style={{ borderTopLeftRadius: showBre == false ? '0' : '12px', borderBottomLeftRadius: showBre == false ? '0' : '12px', background: PopupViewTab === 'crif' ? '#006c67' : '#F1F7FF', color: PopupViewTab === 'crif' ? '#fff' : '#000', zIndex: 0, width: showBre == false ? "100%" : '50%' }} onClick={() => PopupbuttonHandle('crif')} >Crif </button>
                            {
                                showBre == false ? ""
                                    :
                                    <button className="btn btn-outline-primary" style={{ borderTopRightRadius: '12px', borderBottomRightRadius: '12px', background: PopupViewTab === 'internalScoring' ? '#006c67' : '#F1F7FF', color: PopupViewTab === 'internalScoring' ? '#fff' : '#000', zIndex: 0, width: '50%' }} onClick={() => PopupbuttonHandle('internalScoring')}> Internal Scoring </button>
                            }

                        </div>
                    </div>

                    <div className="row from-group" style={{ marginTop: '20px' }}>
                        <div className="col-xs-12" >
                            {
                                PopupViewTab === 'internalScoring' ?
                                    <button className='btn btn-primary' style={{ marginRight: '10px' }} onClick={() => getBreDecisionAdminFn("1")}>Regenerate Decision</button>
                                    : ""}
                            {
                                crifData && crifData?.length > 0 && PopupViewTab === 'crif' ?
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <button className='btn btn-primary' onClick={() => handleRegenerate()}>Regenerate Crif</button>
                                        <button className='btn btn-primary' onClick={() => handleDownload()}>Download Report</button>
                                    </div>
                                    : ''}
                        </div>
                        {
                            PopupViewTab === 'crif' ?
                                <div className="col-xs-12" style={{ marginTop: '20px' }}>
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className='phocket-table' >
                                            <thead style={{ position: 'sticky', top: "0" }}>
                                                <tr>
                                                    <td>User Id</td>
                                                    <td>Name</td>
                                                    <td>Mobile Number</td>
                                                    <td>Overdue Amount</td>
                                                    <td>Crif Score</td>
                                                    <td>Crif Decision</td>
                                                    <td>Crif Date</td>
                                                    <td>is Eligible Based On Score</td>
                                                    <td>Score Category</td>
                                                    <td>Total Loans</td>
                                                    <td>Has Settled</td>
                                                    <td>Has SuitFiled</td>
                                                    <td>Has Written Off</td>

                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr>
                                                    <td>{LeadData?.userId || "-"}</td>
                                                    <td> {LeadData?.firstName + " " + LeadData?.lastName} </td>
                                                    <td>{crifTable?.mobileNumber || "0"}</td>
                                                    <td>{crifTable?.totalOverdueAmount || "0"}</td>
                                                    <td>{crifTable?.crifScore ?? "0"}</td>
                                                    <td>{crifTable?.crifDecision || "0"}
                                                        &nbsp;&nbsp;<i class="fa fa-pencil" aria-hidden="true" style={{ cursor: 'pointer' }} onClick={() => handleEditCRifDecision(true, crifTable)}></i>
                                                    </td>
                                                    <td>{crifTable?.crifDate || "0"}</td>
                                                    <td>{crifTable?.isEligibleBasedOnScore == true ? "Yes" : "No"}</td>
                                                    <td>{crifTable?.scoreCategory || "0"}</td>
                                                    <td>{crifTable?.totalAccounts ?? ""}</td>
                                                    <td>{crifTable?.hasSettled == true ? "Yes" : "No"}</td>
                                                    <td>{crifTable?.hasSuitFiled == true ? "Yes" : "No"}</td>
                                                    <td>{crifTable?.hasWrittenOff == true ? "Yes" : "No"}</td>

                                                </tr>

                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                                : ""}
                        {
                            PopupViewTab === 'internalScoring' ?

                                <div className="col-xs-12" style={{ marginTop: '20px' }}>
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className='phocket-table' >
                                            <thead style={{ position: 'sticky', top: "0" }}>
                                                <tr>
                                                    <td>User Id</td>
                                                    <td>Name</td>
                                                    <td>Loan Amount</td>
                                                    <td>Eligible Amount</td>
                                                    <td>CRIF Score</td>
                                                    <td>CRIF Decision</td>
                                                    <td>Urja Decision</td>
                                                    <td>Customer Type</td>
                                                    <td>Urja Score</td>

                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr>
                                                    <td>{LeadData?.userId || "-"}</td>
                                                    <td> {LeadData?.firstName + " " + LeadData?.lastName} </td>
                                                    <td>{loanCalculationData?.loanAmount || "0"}</td>
                                                    <td>{loanCalculationData?.eligibleAmount || "0"}
                                                        &nbsp;&nbsp;<i class="fa fa-pencil" aria-hidden="true" style={{ cursor: 'pointer' }} onClick={() => handleEditBreDecision("eligibleAmount", loanCalculationData)}></i>
                                                    </td>
                                                    <td>{crifDecisionData?.crifScore || "0"}</td>
                                                    <td>{crifDecisionData?.crifDecision || "-"}</td>
                                                    <td>{crifDecisionData?.breDecision || "-"}
                                                        {admin && admin.rolelist.indexOf(ROLE.EDIT_infitouch_DECISION) >= 0 ?
                                                            <>
                                                                &nbsp;&nbsp;<i class="fa fa-pencil" aria-hidden="true" style={{ cursor: 'pointer' }} onClick={() => handleEditBreDecision("breDecision", crifDecisionData)}></i>
                                                            </>
                                                            : ''}
                                                    </td>
                                                    <td>{TableData?.customerType || "-"}</td>
                                                    <td>{TableData?.breScore || "0"}</td>


                                                </tr>

                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                                : ""}

                    </div>
                    {
                        PopupViewTab === 'internalScoring' ?
                            <>

                                <div className="row" style={{ marginTop: '30px' }}>
                                    <ViewSection viewType={viewType} scoreDetail={scoreDetail} LeadData={LeadData} handleView={handleView} />
                                </div>
                            </>
                            : ''}

                    {
                        PopupViewTab === "crif" ?
                            <CrifSection crifData={crifData} crifDecisionData={crifDecisionData} handleDownload={handleDownload} /> : ''
                    }

                    {
                        BreUpdate?.show ?
                            <div className="background-blur">
                                <div className="popup-main  container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '20%', height: '23.5%', top: '20%' }}>
                                    <i onClick={() => setBReUpdate({ show: false, value: {}, type: '', eligibleAmount: '' })} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                    {
                                        loader ? <Loader /> : ''
                                    }

                                    <div className="text-center">{`Update ${BreUpdate?.type == "breDecision" ? 'Urja Decision' : 'Eligible Amount'}`}</div>
                                    {
                                        BreUpdate?.type == "breDecision" ?
                                            <select className='form-control' value={BreUpdate?.value} onChange={(e) => setBReUpdate({ ...BreUpdate, value: e.target.value, eligibleAmount: '' })} style={{ marginTop: '15px' }}>
                                                <option>Select Option</option>
                                                <option value='Approved'>Approved</option>
                                                <option value='Rejected'>Rejected</option>
                                            </select>
                                            :
                                            BreUpdate?.type == "eligibleAmount" ?
                                                <input className='form-control' type='number' onChange={(e) => setBReUpdate({ ...BreUpdate, value: '', eligibleAmount: e.target.value })} style={{ marginTop: '25px' }} value={BreUpdate?.eligibleAmount} />
                                                : ''}
                                    <div className="" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                        <button className='btn btn-primary' onClick={() => handleUpdateBreDecision()}>Save</button>
                                    </div>
                                </div>
                            </div>
                            : ''}
                    {
                        handlecrif?.show ?
                            <div className="background-blur">
                                <div className="popup-main  container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '40%', height: '40%', top: '20%' }}>
                                    <i onClick={() => handleEditCRifDecision(false, {})} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                    {
                                        loader ? <Loader /> : ''
                                    }

                                    <div className="text-center">{`Update Crif Decision`}</div>
                                    <div className='row' style={{display:'flex',flexDirection:'column',gap:'15px',marginTop:'25px'}}>
                                        <div className='col-xs-12'>
                                            <label>Select Decision</label>
                                            <select className='form-control' value={handlecrif?.val} onChange={(e) => sethandlecrif(prev=>({ ...prev, val: e.target.value }))}>
                                                <option>Select Option</option>
                                                <option value='Approved'>Approved</option>
                                                <option value='Rejected'>Rejected</option>
                                                <option value='NTC'>NTC</option>
                                            </select>
                                        </div>
                                        <div className='col-xs-12'>
                                            <label>Add Remark</label>
                                            <input className='form-control' value={handlecrif?.remarks} onChange={(e) => sethandlecrif(prev=>({ ...prev, remarks: e.target.value }))} />
                                        </div>
                                    </div>

                                    <div className="" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                        <button className='btn btn-primary' onClick={() => savecrifDecision()}>Save</button>
                                    </div>
                                </div>
                            </div>
                            : ''}
                </div>
            </div>
        </>
    )
}
